export enum StateEnum {
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR'
}

export interface StateSliceState {
  state: StateEnum;
}
